import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { CheckCircle, Cancel } from "@material-ui/icons";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<boolean>;
export const Actief = (props: AllProps) => {
    const { t: tDatatypes } = useTranslation('datatypes');
    const { t: tCommon } = useTranslation('common');
    
    const label = props.label || tDatatypes('actiefLabel') || "Actief";
    const displayValue = props.value ? tCommon('active') : tCommon('notActive');
    const icon = props.value ? <CheckCircle /> : <Cancel />;
    
    return (<Caption {...props} caption={label} icon={icon}>
        {displayValue}
    </Caption>)
}
